<template>
  <RevCard class="p-24">
    <h2 class="heading-2 mb-8">{{ i18n(translations.title) }}</h2>

    <div class="flex flex-row items-center">
      <div class="flex-1">
        <p class="body-1 mb-24">
          {{ i18n(translations.subtitle) }}
        </p>
        <p class="body-1 mb-16">
          {{ i18n(translations.infoMessage) }}
        </p>

        <RevButton :to="BACKPACK_LINK" variant="primary">
          {{ i18n(translations.orderNow) }}
        </RevButton>
      </div>

      <RevIllustration
        :alt="i18n(translations.imageAlt)"
        class="hidden lg:flex"
        :height="174"
        src="/img/options/shipping/backpack.png"
        :width="238"
      />
    </div>
  </RevCard>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevButton } from '@ds/components/Button'
import { RevCard } from '@ds/components/Card'
import { RevIllustration } from '@ds/components/Illustration'

import { getExternalLinkList } from '~/constants/externalLinks'

import translations from './BlockBackpack.translations'

const i18n = useI18n()
const { BACKPACK_LINK } = getExternalLinkList(i18n.currentLocale)
</script>
